"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var queryString = require("query-string");
var core_1 = require("@material-ui/core");
var Routes_1 = require("../../../common/enum/Routes");
var collectedFilters_1 = require("../../../common/service/collectedFilters");
var useCheckoutContext_1 = require("../../common/hooks/useCheckoutContext");
var Payment_1 = require("../../commonSteps/payment/components/Payment");
var TransactionErrorTypes_1 = require("../../../common/enum/TransactionErrorTypes");
var PaymentPage = function () {
    var _a;
    var history = react_router_1.useHistory();
    var token = collectedFilters_1.default().filters.token;
    var searchParams = queryString.stringify({ token: token }, { arrayFormat: 'comma' });
    var _b = useCheckoutContext_1.default(), deal = _b.deal, error = _b.error, loading = _b.loading;
    var redirectUnavailableDeal = react_1.useCallback(function () { return history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, {}); }, []);
    var dealChecker = react_1.useCallback(function (error) {
        var _a;
        if (error || ((_a = deal) === null || _a === void 0 ? void 0 : _a.status) === TransactionErrorTypes_1.TransactionErrorTypes.AUTHORIZED) {
            redirectUnavailableDeal();
        }
    }, [error, (_a = deal) === null || _a === void 0 ? void 0 : _a.status]);
    var goToNextStep = function () {
        history.push(__assign(__assign({}, location), { pathname: Routes_1.Routes.CONFIRMATION_RESERVE_ONLINE, search: searchParams }));
    };
    react_1.useEffect(function () {
        dealChecker(error);
    }, [deal, error]);
    return (<core_1.Container data-test={'container:checkout:payment'}>
      <Payment_1.default goToNextStep={goToNextStep} deal={deal} loading={loading}/>
    </core_1.Container>);
};
exports.default = PaymentPage;
